import { type UseControllerProps, type FieldValues, useController } from 'react-hook-form';

import { type TextareaProps, Textarea } from '../Textarea';

type FormTextareaProps<TFieldValues extends FieldValues> = UseControllerProps<TFieldValues> &
  Omit<TextareaProps, 'error'>;

function FormTextarea<TFieldValues extends FieldValues = FieldValues>(
  props: Readonly<FormTextareaProps<TFieldValues>>,
) {
  const {
    field: { ref, ...field },
    fieldState: { error },
  } = useController({ ...props, name: props.name });

  return (
    <Textarea
      {...props}
      {...field}
      error={!!error}
      helperText={error?.message ?? props.helperText}
      onChange={(event) => {
        field.onChange(event);
        props.onChange?.(event);
      }}
      required={Boolean(props.rules?.required ?? props.required)}
      ref={ref}
    />
  );
}

export default FormTextarea;
export type { FormTextareaProps };
